import { useContext } from 'react';

import { XYChartSelectConfigContext } from '../context/XYChartSelectConfig.context.js';

export const useSelectConfig = () => useContext(XYChartSelectConfigContext);
